import styled from "@emotion/styled";
import { HyperLink } from "src/atoms/HyperLink";

const StyledProductMeta = styled.div`
  .ProductMeta__accordion {
    border-top: 1px solid ${({ theme }) => theme.colors.primary.platinumLight};
  }

  .ProductMeta__accordionPanel {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.primary.platinumLight};
  }

  .ProductMeta__offers {
    display: flex;
    flex-wrap: wrap;

    list-style: none;
    margin: 0;
    padding: 0;

    margin-top: -8px;
  }

  .ProductMeta__offer {
    margin-top: 8px;
    display: flex;
    width: 50%;
  }

  .ProductMeta__offerIcon {
    width: 16px;
    height: 22px;
    margin-left: 2px;

    path {
      stroke: ${({ theme }) => theme.colors.tone.black};
    }
  }

  .ProductMeta__offerText {
    margin-left: 10px;
    font-size: 14px;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.tone.black};
  }

  .ProductMeta__paymentProviders {
    display: flex;
    flex-wrap: wrap;
    margin-top: -16px;
    margin-left: -16px;

    .ProductMeta__paymentProviderContainer {
      margin-top: 16px;
      margin-left: 16px;
      height: 48px;
      width: calc(25% - 16px);
      justify-content: center;
      align-items: center;
      display: flex;
      position: relative;

      border: 1px solid ${({ theme }) => theme.colors.primary.platinumLight};
    }

    img {
      height: 100%;
      object-fit: cover;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
      .ProductMeta__paymentProviderContainer {
        width: calc(20% - 16px);
      }
    }

    @media (max-width: 600px) {
      .ProductMeta__paymentProviderContainer {
        width: calc(25% - 16px);
      }
    }

    @media (max-width: ${({ theme }) => theme.breakpoints[1]}) {
      .ProductMeta__paymentProviderContainer {
        width: calc(33% - 16px);
      }
    }

    @media (max-width: ${({ theme }) => theme.breakpoints[0]}) {
      .ProductMeta__paymentProviderContainer {
        width: calc(50% - 16px);
      }
    }
  }

  .ProductMeta__paymentThuiswinkelWaarborg {
    margin-top: 16px;
    height: 32px;
  }

  .ProductMeta__shippingAndReturns {
    margin-top: 16px;
  }
`;

const ProductInfoButton = styled(HyperLink)`
  flex-shrink: 0;
  width: auto;
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  height: 24px;
  padding: ${({ theme }) => theme.space[0]}px;

  svg {
    fill: none;
  }
`;

const AccordionHeading = styled.h3`
  font-size: 14px;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  line-height: 24px;
  text-transform: none;
`;

export { StyledProductMeta, ProductInfoButton, AccordionHeading };
